import { useState } from "react";

const SendAbsencesDialog = ({ students }) => {
    const [selectedMethod, setSelectedMethod] = useState("");
    const mobileNumbers = [...new Set(
        students.map((student) => student.parentMobile?.trim()).filter(Boolean)
    )];
    const mobileGroups = Array.from(
        { length: Math.ceil(mobileNumbers.length / 15) },
        (_, index) => mobileNumbers.slice(index * 15, index * 15 + 15)
    );

    const methods = [
        { id: "phone-sms", label: "ارسال پیامک از طریق همین گوشی" },
        { id: "cloud-sms", label: "ارسال پیامک به‌صورت ابری" },
        { id: "cloud-voice", label: "تماس صوتی ابری" },
    ];

    return (
        <div
            className="modal fade"
            id="SendAbsencesDialog"
            tabIndex="-1"
            aria-labelledby="SendAbsencesDialogLabel"
            aria-hidden="true"
            dir="rtl"
        >
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content border-0 rounded-4 shadow">
                    <div className="modal-header">
                        <div>
                            <h2 className="modal-title fs-5 fw-bold" id="SendAbsencesDialogLabel">
                                روش ارسال به والدین
                            </h2>
                        </div>
                        <button
                            type="button"
                            className="btn-close ms-0 me-auto"
                            data-bs-dismiss="modal"
                            aria-label="بستن"
                        />
                    </div>

                    <div className="modal-body">
                        <div className="d-grid gap-2" role="radiogroup" aria-label="روش ارسال">
                            {methods.map((method) => (
                                <div key={method.id}>
                                    <label
                                        htmlFor={method.id}
                                        className={`border rounded-3 p-3 d-flex align-items-center gap-3 ${selectedMethod === method.id ? "border-primary bg-primary-subtle" : "bg-white"}`}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <input
                                            id={method.id}
                                            className="form-check-input m-0"
                                            type="radio"
                                            name="send-method"
                                            value={method.id}
                                            checked={selectedMethod === method.id}
                                            onChange={() => setSelectedMethod(method.id)}
                                        />
                                        <span className="fw-semibold">{method.label}</span>
                                    </label>

                                    {method.id === "phone-sms" && selectedMethod === method.id && (
                                        <div className="d-grid gap-2 mt-2">
                                            {mobileGroups.length > 0 ? (
                                                mobileGroups.map((group, index) => {
                                                    const firstNumber = index * 15 + 1;
                                                    const lastNumber = firstNumber + group.length - 1;

                                                    return (
                                                        <a
                                                            key={`${index}-${group[0]}`}
                                                            className="btn btn-outline-primary"
                                                            href={`sms:${group.join(",")}`}
                                                        >
                                                            پیامک به شماره‌های {firstNumber.toLocaleString("fa-IR")} تا {lastNumber.toLocaleString("fa-IR")}
                                                        </a>
                                                    );
                                                })
                                            ) : (
                                                <p className="small text-muted mb-0 py-2" role="status">
                                                    شماره تماسی برای ارسال ثبت نشده است.
                                                </p>
                                            )}
                                        </div>
                                    )}

                                    {(method.id === "cloud-sms" || method.id === "cloud-voice") &&
                                        selectedMethod === method.id && (
                                            <p className="small text-muted mb-0 mt-2 px-3" role="status">
                                                برای استفاده از این روش، نیاز به خرید اشتراک دارید.
                                            </p>
                                        )}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            data-bs-dismiss="modal"
                        >
                            بستن
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SendAbsencesDialog;
